
import { useState, useEffect } from "react";
import { FaStar, FaUser, FaImage, FaVideo, FaPaperPlane } from "react-icons/fa";
import { motion } from "framer-motion";
import MainNavbar from "../MainNavbar";
import "./ReviewPage.css";
import { useContext } from "react";
import AlertContext from "../../../contexts/AlertContext";

export default function ReviewPage() {
  const [reviews, setReviews] = useState([]);
  const [sortOption, setSortOption] = useState("latest");
  const [page, setPage] = useState(1);
  const [newReview, setNewReview] = useState("");
  const [newUser, setNewUser] = useState("");
  const [newGender, setNewGender] = useState("");
  const [rating, setRating] = useState(0);
  const [impressiveType, setImpressiveType] = useState("");
  const [newImage, setNewImage] = useState(null);
  const [error, setError] = useState("");
  const { showAlert } = useContext(AlertContext);
  useEffect(() => {
    fetchReviews();
  }, []);

  useEffect(() => {
    let sortedReviews = [...reviews];
    if (sortOption === "highest") {
      sortedReviews.sort((a, b) => b.rating - a.rating);
    } else if (sortOption === "mostLiked") {
      sortedReviews.sort((a, b) => b.likes - a.likes);
    } else {
      sortedReviews.sort((a, b) => new Date(b.date) - new Date(a.date));
    }
    setReviews(sortedReviews);
  }, [sortOption]);

  const fetchReviews = async () => {
    try {
      const response = await fetch("https://back.varankal.com/api/reviews");
      if (!response.ok) throw new Error("Failed to fetch reviews");
      const data = await response.json();
      setReviews(data);
    } catch (error) {
      console.error("Error fetching reviews:", error);
    }
  };
  const handleSubmitReview = async (e) => {
    e.preventDefault();

    if (!newReview || !newUser || !newGender || rating === 0 || !impressiveType) {
      setError("All fields are required.");
      return;
    }

    // Optional: Convert image file to Base64 if needed
    let imageBase64 = null;
    if (newImage) {
      const reader = new FileReader();
      reader.onloadend = async () => {
        imageBase64 = reader.result;

        try {
          const response = await fetch("https://back.varankal.com/api/reviews", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              user: newUser,
              gender: newGender,
              review: newReview,
              rating,
              impressiveType,
              imageBase64 // optional
            })
          });

          if (!response.ok) throw new Error("Failed to submit review");

          // Refresh list and reset form
          fetchReviews();
          setNewReview("");
          setNewUser("");
          setNewGender("");
          setRating(0);
          setImpressiveType("");
          setNewImage(null);

          window.showAlert("🎉 Review submitted successfully! Thank you for sharing your experience.");
        } catch (error) {
          setError("Error submitting review: " + error.message);
        }
      };
      reader.readAsDataURL(newImage); // trigger FileReader
    } else {
      // No image? Just send it directly
      try {
        const response = await fetch("https://back.varankal.com/api/reviews", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            user: newUser,
            gender: newGender,
            review: newReview,
            rating,
            impressiveType,
          })
        });

        if (!response.ok) throw new Error("Failed to submit review");

        fetchReviews();
        setNewReview("");
        setNewUser("");
        setNewGender("");
        setRating(0);
        setImpressiveType("");
        setNewImage(null);

        window.showAlert("🎉 Review submitted successfully! Thank you for sharing your experience.");
      } catch (error) {
        setError("Error submitting review: " + error.message);
      }
    }
  };


  return (
    <>
      <MainNavbar />
      <section className="review-pageW99">
        <h2 className="section-titleW99">Share Your Experience</h2>
        <form onSubmit={handleSubmitReview} className="review-formW99">
          <div className="input-groupW99">
            <FaUser className="iconW99" />
            <input type="text" placeholder="Your Name" value={newUser} onChange={(e) => setNewUser(e.target.value)} required />
          </div>
          <select value={newGender} onChange={(e) => setNewGender(e.target.value)} required>
            <option value="" disabled>Select Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>
          <textarea
            className="custom-textareaW99"
            placeholder="Write your review..."
            value={newReview}
            onChange={(e) => setNewReview(e.target.value)}
            required
          />
          <select value={impressiveType} onChange={(e) => setImpressiveType(e.target.value)} required>
            <option value="" disabled>Select Impressive Aspect</option>
            <option value="Service">Service</option>
            <option value="Support">Support</option>
            <option value="Features">Features</option>
            <option value="Pricing">Pricing</option>
          </select>
          <div className="file-uploadW99">
            <label><FaImage /> Upload Image<input type="file" accept="image/*" onChange={(e) => setNewImage(e.target.files[0])} /></label>
            {/* Removed the video upload option */}
          </div>
          <div className="star-ratingW99">
            {[...Array(5)].map((_, index) => (
              <FaStar key={index} className={index < rating ? "activeW99" : ""} onClick={() => setRating(index + 1)} />
            ))}
          </div>
          <motion.button type="submit" className="submit-buttonW99" whileHover={{ scale: 1.1 }}><FaPaperPlane /> Submit Review</motion.button>
        </form>
      </section>
    </>
  );
}
